import script from "./DataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=ts"

import "./DataTable.vue?vue&type=style&index=0&id=62f306ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f306ac"]])

export default __exports__